import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { AdministrationService } from '../../../services/administration.service'
import { WMSValidators } from '../../../shared/validators';

@Component({
    selector: 'dialog-add-new-fare-tax',
    templateUrl: 'dialog.addnewfaretax.html',
    styleUrls: ['./dialog.addnewfaretax.css']
})
export class AddNewFareTaxDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    addNewFareTaxForm: FormGroup;
    loading: boolean = false;
    errorMessage: string = '';

    constructor(public dialogRef: MatDialogRef<AddNewFareTaxDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private administrationService: AdministrationService,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        this.addNewFareTaxForm = new FormGroup({
            pukalNo: new FormControl({ value: this.data.AccNo, disabled: false }, [Validators.required]),
            fareObjId: new FormControl({ value: this.data.FareObjId, disabled: false }, [Validators.required, Validators.maxLength(15)]),
            taxObjId: new FormControl({ value: this.data.TaxObjId, disabled: false }, [Validators.required])
        });
    }

    onSave(form: FormGroup) {
        let cfm = confirm("Are you sure want to add Pukal No?");

        if (cfm) {
            this.loading = true;
            let fareTaxDetail = {
                TaxId: null,
                Acc_No: this.addNewFareTaxForm.get('pukalNo')!.value,
                Fare_Obj_Id: this.addNewFareTaxForm.get('fareObjId')!.value,
                Tax_Obj_Id: this.addNewFareTaxForm.get('taxObjId')!.value
            }

            let save_sub = this.administrationService.addFareTaxObjIdList(fareTaxDetail)
                .subscribe(
                    (value) => {
                        this.loading = false;
                        if (value.status === 204) {
                        } else if (value.status === 200) {
                            this.dialogRef.close('Add successful');
                        } else {
                            this.openSnackBar('Error adding pukal no details.', '');
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(save_sub);
        } else {
            this.loading = false;
        }
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}